require('./bootstrap');
import './common/helpers';

window.$ = window.jQuery = require('jquery');
window.moment = require('moment-timezone');
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
